import { Sprite, Texture } from 'pixi.js';

import { Shared } from '../../App';
import { CullingComponent } from '../components/CullingComponent';
import { BaseEntity } from './BaseEntity';

export const defaultSpriteParams = {
    texture: '' as string | Texture,
    x: 0,
    y: 0,
    z: 0,
    r: 0,
    sx: 1,
    sy: 1,
    ax: 0.5,
    ay: 0.5,
    alpha: 1,
    tint: 0xFFFFFF,
};

export type SpriteParams = typeof defaultSpriteParams;

export class SpriteEntity extends BaseEntity
{
    public sprite!: Sprite;
    public params!: SpriteParams;
    public culling: CullingComponent;

    constructor()
    {
        super({ view: new Sprite() });
        this.culling = this.addComponent(CullingComponent);
        this.sprite = this.view as Sprite;
        this.sprite.anchor.set(0.5);
    }

    public build(params: Partial<SpriteParams> = {}): void
    {
        this.params = { ...defaultSpriteParams, ...params };

        const texture = this.params.texture instanceof Texture
            ? this.params.texture
            : Shared.assets.getTexture(this.params.texture);

        this.sprite.texture = texture;
        this.sprite.scale.x = this.params.sx;
        this.sprite.scale.y = this.params.sy;
        this.rotation = this.params.r;
        this.x = this.params.x;
        this.y = this.params.y;
        this.z = this.params.z;
        this.sprite.anchor.x = this.params.ax;
        this.sprite.anchor.y = this.params.ay;
        this.sprite.alpha = this.params.alpha;
        this.sprite.tint = this.params.tint;

        this.culling.updateBounds();
    }
}
